import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import App from "./App";

/**
 * Enkel router-wrapper: lägger på BrowserRouter men låter App behålla
 * sin nuvarande state-styrning (activePage m.m.) tills vi migrerar fullt.
 */
export function AppRoutes(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/fakturering" element={<App />} />
        <Route path="/rapporter" element={<App />} />
        <Route path="/rapporter/klimat" element={<App />} />
        <Route path="/rapporter/:id" element={<App />} />
        <Route path="/vidareforsaljning" element={<App />} />
        <Route path="/kunder" element={<App />} />
        <Route path="/certificates" element={<App />} />
        <Route path="/users" element={<App />} />
        <Route path="/product-types" element={<App />} />
        <Route path="/bug-board" element={<App />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
